

import { Options, Vue } from "vue-class-component";
// import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'

@Options({
  components: {},
})
export default class Fail extends Vue {
  mounted() {
    
  }
  goDestroyIndex() {
    // @ts-ignore
    this.$router.replace({
      name: 'DestroyAccount'
    })
  }
}
